<template>
  <div>
    <b-modal
      id="modalAddArticle"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
      :title="titleModal"
    >
      <template #default>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row">
            <div class="col-md-6 col-lg-4">
              <div class="form-group">
                <label for="reference"
                  >Référence <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('reference'),
                  }"
                  id="reference"
                  v-model="form.reference"
                  type="text"
                  placeholder="Référence"
                  maxlength="30"
                  required
                />
                <has-error :form="form" field="reference"></has-error>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 mt-n4 mt-lg-0">
              <div class="form-group">
                <label for="designation"
                  >Désignation <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('designation'),
                  }"
                  id="designation"
                  v-model="form.designation"
                  type="text"
                  placeholder="Désignation"
                  maxlength="50"
                  required
                />
                <has-error :form="form" field="designation"></has-error>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 mt-lg-0">
              <div class="form-group">
                <label for="famille"
                  >Famille de l'article
                  <span class="text-danger">*</span></label
                >
                <v-custom-select
                  label="nom"
                  :options="familles"
                  :reduce="(famille) => famille.uuid"
                  v-model="form.famille"
                  placeholder="Famille de l'article"
                >
                  <template v-slot:option="{ nom }">
                    <h5 style="margin: 0">{{ nom }}</h5>
                  </template>
                  <template #no-options> Aucune donnée </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="famille"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('famille'),
                    }"
                  />
                  <has-error :form="form" field="famille"></has-error>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 mt-n4">
              <div class="form-group">
                <label for="unite"
                  >Unité de l'article <span class="text-danger">*</span></label
                >
                <v-custom-select
                  label="nom"
                  :options="unites"
                  :reduce="(unite) => unite.uuid"
                  v-model="form.unite"
                  placeholder="Unité de l'article"
                >
                  <template v-slot:option="{ nom, code }">
                    <h5 style="margin: 0">{{ nom }} ( {{ code }} )</h5>
                  </template>
                  <template #no-options> Aucune donnée </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="unite"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('unite'),
                    }"
                  />
                  <has-error :form="form" field="unite"></has-error>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n4">
              <div class="form-group">
                <label for="cout_revient"
                  >Coût de revient <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('cout_revient'),
                  }"
                  id="cout_revient"
                  v-model.number="form.cout_revient"
                  type="text"
                  placeholder="Coût de revient"
                  @focus="$event.target.select()"
                  required
                />
                <has-error :form="form" field="cout_revient"></has-error>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n4">
              <div class="form-group">
                <label for="prix_vente"
                  >Prix de vente <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('prix_vente'),
                  }"
                  id="prix_vente"
                  v-model.number="form.prix_vente"
                  type="text"
                  placeholder="Prix de vente"
                  @focus="$event.target.select()"
                  required
                />
                <has-error :form="form" field="prix_vente"></has-error>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 mt-n4">
              <div class="form-group">
                <label for="prix_vente_min"
                  >Prix de vente min <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('prix_vente_min'),
                  }"
                  id="prix_vente_min"
                  v-model.number="form.prix_vente_min"
                  type="text"
                  placeholder="Prix de vente minimum"
                  @focus="$event.target.select()"
                  required
                />
                <has-error :form="form" field="prix_vente_min"></has-error>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n4">
              <div class="form-group">
                <label for="quantite_min"
                  >Quantité min <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('quantite_min'),
                  }"
                  id="quantite_min"
                  v-model.number="form.quantite_min"
                  type="text"
                  placeholder="Quantité min"
                  @focus="$event.target.select()"
                  required
                />
                <has-error :form="form" field="quantite_min"></has-error>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n4">
              <div class="form-group">
                <label for="tva"
                  >TVA général <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('tva'),
                  }"
                  id="tva"
                  v-model.number="form.tva"
                  type="text"
                  placeholder="Taux TVA général"
                  @focus="$event.target.select()"
                  required
                />
                <has-error :form="form" field="tva"></has-error>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n4">
              <div class="form-group">
                <label for="ligne_budgetaire"
                  >Ligne budgétaire <span class="text-danger">*</span></label
                >
                <v-custom-select
                  label="nom"
                  :options="ligneBudgetaires"
                  :reduce="(ligneBudgetaire) => ligneBudgetaire.uuid"
                  v-model="form.ligne_budgetaire"
                  placeholder="Ligne budgétaire"
                >
                  <template v-slot:option="{ nom }">
                    <h5 style="margin: 0">{{ nom }}</h5>
                  </template>
                  <template #no-options> Aucune donnée </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="ligne_budgetaire"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('ligne_budgetaire'),
                    }"
                  />
                  <has-error :form="form" field="ligne_budgetaire"></has-error>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 mt-n4">
              <div class="form-group">
                <label for="entrepot"
                  >Entrepôt par défaut <span class="text-danger">*</span></label
                >
                <v-custom-select
                  label="nom"
                  :options="entrepots"
                  :reduce="(entrepot) => entrepot.uuid"
                  v-model="form.entrepot"
                  placeholder="Entrepôt par défaut"
                >
                  <template v-slot:option="{ nom, pays, description }">
                    <h5 style="margin: 0">{{ nom }}</h5>
                    <span v-if="pays" class="d-block"> Pays : {{ pays }} </span>
                    <span v-if="description" class="d-block">
                      Description : {{ description }}
                    </span>
                  </template>
                  <template #no-options> Aucune donnée </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="entrepot"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('entrepot'),
                    }"
                  />
                  <has-error :form="form" field="entrepot"></has-error>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n4">
              <div class="form-group">
                <label for="stock_securite"
                  >Stock de sécurité <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('stock_securite'),
                  }"
                  id="stock_securite"
                  v-model.number="form.stock_securite"
                  type="text"
                  placeholder="Stock de sécurité"
                  @focus="$event.target.select()"
                  required
                />
                <has-error :form="form" field="stock_securite"></has-error>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 mt-lg-0">
              <div class="custom-control custom-checkbox mb-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="achat"
                  v-model="form.achat"
                />
                <label class="custom-control-label" for="achat"
                  >Disponible pour achat ?</label
                >
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-lg-0">
              <div class="custom-control custom-checkbox mb-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="vente"
                  v-model="form.vente"
                />
                <label class="custom-control-label" for="vente"
                  >Disponible pour vente ?</label
                >
              </div>
            </div>

            <div
              class="col-md-6 col-lg-4 mt-lg-0"
              v-if="form.type === 'produits'"
            >
              <div class="custom-control custom-checkbox mb-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="lot"
                  v-model="form.lot"
                />
                <label class="custom-control-label" for="lot"
                  >Gestion par lot ?</label
                >
              </div>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalAddArticle')"
        >
          Fermer
        </button>

        <button
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          Enregistrer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/article_stock/article';
import Form from 'vform';
export default {
  data() {
    return {
      form: new Form({
        tva: 0,
        prix_vente: 0,
        quantite_min: 1,
        prix_vente_min: 0,
        unite: null,
        famille: null,
        ligne_budgetaire: null,
        entrepot: null,
        type: 'produits',
      }),
      entrepots: [],
      unites: [],
      familles: [],
      ligneBudgetaires: [],
      titleModal: 'Ajout de nouvel article',
    };
  },
  methods: {
    async showModal() {
      this.entrepots = [];
      this.unites = [];
      this.familles = [];
      this.ligneBudgetaires = [];

      await window.axios
        .get(URL.GET_REQUIREMENTS)
        .then((resp) => {
          this.entrepots = resp.data.entrepots;
          this.unites = resp.data.unites;
          this.familles = resp.data.familles;
          this.ligneBudgetaires = resp.data.ligne_budgetaires;
        })
        .catch();

      await this.$bvModal.show('modalAddArticle');
    },
    submit() {
      this.$bvModal.hide('modalAddArticle');

      this.form
        .post(URL.ARTICLE, {
          params: {
            stock_details: true,
          },
        })
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();

          let currentArticle = {
            uuid: resp.data.article.uuid,
            designation: resp.data.article.designation,
            reference: resp.data.article.reference,
            unite: resp.data.article.unite,
            quantite: 1,
            stock: resp.data.article.stock,
            type: this.currentType,
          };

          this.$emit('onSavedArticle', currentArticle);
        })
        .catch(() => {
          this.$bvModal.show('modalAddArticle');
        });
    },
  },
  props: ['currentType'],
};
</script>

<style scoped lang="scss"></style>
